var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShift24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shift-24px",
    transform: "translate(293 -385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M-273.9,394.3l-6.7-6.7a.967.967,0,0,0-1.4,0l-6.3,6.7a1,1,0,0,0,.7,1.7h2.5v9a.945.945,0,0,0,1,1h6a.945.945,0,0,0,1-1v-9h2.4A.991.991,0,0,0-273.9,394.3Z",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 24,
    height: 24,
    transform: "translate(-293 385)",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShift24Px);
export default __webpack_public_path__ + "static/media/shift-24px.841e4abcb8b1d55a77df3d47da669cf3.svg";
export { ForwardRef as ReactComponent };